import { render, staticRenderFns } from "./LocationsAmenitiesList.vue?vue&type=template&id=4a6c54fa"
import script from "./LocationsAmenitiesList.vue?vue&type=script&lang=js"
export * from "./LocationsAmenitiesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports